import view from "./view";

class AddRecipeView extends view {
  _parentElement = document.querySelector(".upload");
  _message = "Recipe was successfully uploaded!";
  _window = document.querySelector(".add-recipe-window");
  _overlay = document.querySelector(".overlay");
  _btnOpen = document.querySelector(".nav__btn--add-recipe");
  _btnClose = document.querySelector(".btn--close-modal");

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
  }

  toggleWindow() {
    this._overlay.classList.toggle("hidden");
    this._window.classList.toggle("hidden");
  }

  _addHandlerShowWindow() {
    this._btnOpen.addEventListener("click", () => {
      // Reset the form markup before showing the modal
      this._parentElement.innerHTML = this._generateMarkup();
      this.toggleWindow();
    });
  }

  _addHandlerHideWindow() {
    this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
    this._overlay.addEventListener("click", this.toggleWindow.bind(this));
  }

  _generateMarkup() {
    return `
      <div class="upload__form-fields">
        <p class="upload__small-text">
          Scroll within this area to fill the rest of the form
        </p>
        <div class="upload__column">
          <h3 class="upload__heading">Recipe data</h3>
          <label>Title</label>
          <input placeholder="Chilli con carne" required name="title" type="text" />
          <label>URL</label>
          <input placeholder="Link to instructions" required name="sourceUrl" type="text" />
          <label>Image URL</label>
          <input placeholder="https://example.com/image.jpg" required name="image" type="text" />
          <label>Publisher</label>
          <input placeholder="The Saucemaster" required name="publisher" type="text" />
          <label>Prep time</label>
          <input placeholder="120" required name="cookingTime" type="number" />
          <label>Servings</label>
          <input placeholder="4" required name="servings" type="number" />
        </div>

        <div class="upload__column">
          <h3 class="upload__heading">Ingredients</h3>
          <label>Ingredient 1</label>
          <input placeholder="0.5,kg,Rice" type="text" required name="ingredient-1" />
          <label>Ingredient 2</label>
          <input placeholder="1,,Avocado" type="text" name="ingredient-2" />
          <label>Ingredient 3</label>
          <input placeholder=",,salt" type="text" name="ingredient-3" />
          <label>Ingredient 4</label>
          <input type="text" name="ingredient-4" placeholder="Format: 'Quantity,Unit,Description'" />
          <label>Ingredient 5</label>
          <input type="text" name="ingredient-5" placeholder="Format: 'Quantity,Unit,Description'" />
          <label>Ingredient 6</label>
          <input type="text" name="ingredient-6" placeholder="Format: 'Quantity,Unit,Description'" />
        </div>
      </div>

      <button class="btn upload__btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free 7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M176 544C96.5 544 32 479.5 32 400C32 336.6 73 282.8 129.9 263.5C128.6 255.8 128 248 128 240C128 160.5 192.5 96 272 96C327.4 96 375.5 127.3 399.6 173.1C413.8 164.8 430.4 160 448 160C501 160 544 203 544 256C544 271.7 540.2 286.6 533.5 299.7C577.5 320 608 364.4 608 416C608 486.7 550.7 544 480 544L176 544zM337 255C327.6 245.6 312.4 245.6 303.1 255L231.1 327C221.7 336.4 221.7 351.6 231.1 360.9C240.5 370.2 255.7 370.3 265 360.9L296 329.9L296 432C296 445.3 306.7 456 320 456C333.3 456 344 445.3 344 432L344 329.9L375 360.9C384.4 370.3 399.6 370.3 408.9 360.9C418.2 351.5 418.3 336.3 408.9 327L336.9 255z"/></svg>
        <span>Upload</span>
      </button>
    `;
  }

  addHandlerUpload(handler) {
    this._parentElement.addEventListener("submit", function (e) {
      e.preventDefault();
      const formDataArr = [...new FormData(this)];
      const formData = Object.fromEntries(formDataArr);
      handler(formData);
    });
  }
}

export default new AddRecipeView();
